export enum VCSDetectionType {
    Runtime = 'runtime',
    Framework = 'framework',
}
